<script setup lang="ts">
import { RouterView } from 'vue-router'

import MusicPlayer from '@/components/MusicPlayer.vue'
</script>

<template>
  <RouterView />
  <MusicPlayer />
</template>
